export const collectValueByKey = (key, valueKey) => (acc, item) => {
  const targetKey = item[key];
  const targetValue = item[valueKey];
  return {
    ...acc,
    [targetKey]: targetValue,
  };
};
